import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ladeFinanzen, selectBuchungenStatus } from 'modules/finanzen/features/finanzenSlice';
import {
  ladeInvestitionen,
  ladeDokumente,
  ladeDepotWerte,
  selectInvestitionenStatus,
} from 'modules/investitionen/features/investitionenSlice';
import { pruefeTresorStatus, selectTresorStatus } from 'core/features/sicherheit/sicherheitSlice';
import { projectVisited } from 'core/features/projects/projectsSlice';
import GesichertHinweis from 'core/features/sicherheit/GesichertHinweis';

/**
 * Absicherung fuer alle Finanzen-Seiten (Buchungen + Investitionsorte): rendert
 * die Inhalte nur im gesicherten Modus. Beim Entsperren werden beide Datensaetze
 * geladen; danach teilen sich alle Seiten diesen Zustand.
 */
export default function GesichertGate({ children }) {
  const dispatch = useDispatch();
  const tresorStatus = useSelector(selectTresorStatus);
  const buchungenStatus = useSelector(selectBuchungenStatus);
  const investitionenStatus = useSelector(selectInvestitionenStatus);
  const kryptoVerfuegbar = typeof window !== 'undefined' && window.crypto && window.crypto.subtle;

  useEffect(() => {
    if (!kryptoVerfuegbar) return;
    dispatch(projectVisited('finanzen'));
    dispatch(pruefeTresorStatus());
  }, [dispatch, kryptoVerfuegbar]);

  useEffect(() => {
    if (tresorStatus !== 'unlocked') return;
    if (buchungenStatus === 'idle') dispatch(ladeFinanzen());
    if (investitionenStatus === 'idle') {
      dispatch(ladeInvestitionen());
      dispatch(ladeDokumente());
      dispatch(ladeDepotWerte());
    }
  }, [tresorStatus, buchungenStatus, investitionenStatus, dispatch]);

  if (!kryptoVerfuegbar) return <GesichertHinweis bereich="Der Finanzbereich" />;
  if (tresorStatus === 'unknown') return <p className="text-center text-ink-muted">Lade…</p>;
  if (tresorStatus !== 'unlocked') return <GesichertHinweis bereich="Der Finanzbereich" />;
  return children;
}
